// entry.js
import React from 'react';
import { Provider } from 'react-redux';

import store from './store';

import { Route, Routes, Navigate, BrowserRouter } from 'react-router-dom';

import { AppLayout } from './layouts/app-layout';

import { changeLocale } from './utils/localize';

import './assets/semantic.css';
import './assets/main.css';

changeLocale('cs');

import { createRoot } from 'react-dom/client';
import { QueueListPage } from './features/queues/pages/queue-list-page';
import { SettingsPage } from './features/settings/pages/settings-page';
import { ProviderMessage } from './components/provider-message';
import { QueueSettingsPage } from './features/queue-settings/pages/queue-settings-page';
const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route path="queues" element={<QueueListPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="queues/:id/settings" element={<QueueSettingsPage />} />
          <Route path="/provider-message" element={<ProviderMessage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </Provider>
);
